import type { BaseMapId } from "../map/presets";

interface Props {
  baseMap: BaseMapId;
  liveTraffic: boolean;
}

export function MapProvenance({ baseMap, liveTraffic }: Props) {
  return (
    <>
      {liveTraffic && (
        <div className="traffic-legend mono" role="status" aria-label="Live traffic speed legend">
          <div className="traffic-legend-head">
            <span className="traffic-live-dot" aria-hidden />
            <strong>LIVE TRAFFIC</strong>
            <span>≈5 MIN</span>
          </div>
          <div className="traffic-legend-scale" aria-hidden="true">
            <span className="traffic-free" />
            <span className="traffic-slow" />
            <span className="traffic-heavy" />
          </div>
          <div className="traffic-legend-labels">
            <span>FREE</span><span>SLOW</span><span>HEAVY</span>
          </div>
          <a href="https://live.iticfoundation.org/" target="_blank" rel="noreferrer">
            LONGDO / iTIC ↗<span className="sr-only"> (opens in a new tab)</span>
          </a>
        </div>
      )}
      <div className="map-attribution mono" aria-label="Map data attribution">
        {baseMap === "aerial" ? (
          <span>ESRI WORLD IMAGERY · </span>
        ) : baseMap === "topo" ? (
          <span>OPENTOPOMAP · </span>
        ) : baseMap === "night" || baseMap === "true-color" ? (
          // Night (VIIRS Day/Night Band) and True colour (VIIRS NOAA-20) are
          // NASA GIBS products — attribution is a condition of use (audit #18).
          <span>
            <a href="https://earthdata.nasa.gov/gibs" target="_blank" rel="noreferrer">
              NASA GIBS
            </a>
            {baseMap === "night" ? " · VIIRS DAY/NIGHT BAND · " : " · VIIRS NOAA-20 · "}
          </span>
        ) : null}
        <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">© OSM</a>
        <span> · </span>
        <a href="https://www.esri.com" target="_blank" rel="noreferrer">Esri</a>
        {liveTraffic && <span> · LONGDO TRAFFIC / iTIC</span>}
      </div>
    </>
  );
}

